import ECheckInvoiceTable from './ECheckInvoiceTable';

export default ECheckInvoiceTable;
